export const COMPANIES_NEAR_ME_FILTERS_STORAGE_KEY = 'companies-near-me-filters';
export const COMPANIES_NEAR_ME_FEED_FORM_STORAGE_KEY = 'companies-near-me-feed-form';
export const ACTIVE_CATEGORIES_STORAGE_KEY = 'companies-search-active-categories';
